<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item :to="{ path: '/cert_list/1' }">证书管理</el-breadcrumb-item>
      <el-breadcrumb-item>选中发货</el-breadcrumb-item>
    </el-breadcrumb>
    <el-table
      class="table"
      :data="certSelects"
    >
      <el-table-column
        prop="certType"
        label="证书类型"
        align="center"
        width="200">
      </el-table-column>
      <el-table-column
        prop="stuName"
        label="学员姓名"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="stuPhone"
        label="学员手机号"
        align="center"
        width="150">
      </el-table-column>
    </el-table>
    <div class="info-title">发货信息</div>
    <el-row :gutter="10" class="info-wrapper">
      <el-col :span="13">
        <el-form ref="form" disabled label-width="100px">
          <el-form-item label="收件地址">
            <el-input v-model="addressStr"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4" v-if="!expressed">
        <div class="grid-content">
          <el-button
            type="primary"
            v-clipboard:copy="addressStr"
            v-clipboard:success="_copyAddress"
            v-clipboard:error="_copyError"
          >复制</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="express-wrapper" v-if="!expressed">
      <el-col :span="4" style="padding-left: 0">
        <div class="grid-content">
          <el-select v-model="expressCompany" clearable placeholder="快递公司">
            <el-option
              v-for="item in companyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="1">&nbsp;</el-col>
      <el-col :span="6" style="padding-left: 0">
        <div class="grid-content">
          <el-input placeholder="" v-model="expressNo">
            <template slot="prepend">快递单号</template>
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="margin-top: 20px;" v-if="!expressed">
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="3" style="padding-left: 0">
        <div class="grid-content">
          <el-button type="primary" @click="_certExpress" :loading="loading">发货</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="info-wrapper" v-if="expressed">
      <el-col :span="8">
        <el-form ref="form" disabled :model="expressInfo" label-width="100px">
          <el-form-item label="快递公司">
            <el-input v-model="expressInfo.expressCoDesc"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="8">
        <el-form ref="form" disabled :model="expressInfo" label-width="100px">
          <el-form-item label="快递单号">
            <el-input v-model="expressInfo.expressNo"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="8">
        <el-form ref="form" disabled :model="expressInfo" label-width="100px">
          <el-form-item label="发货时间">
            <el-input v-model="expressInfo.entryTime"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script type="text/ecmascript-6">
  import { certExpress } from '@/api/cert';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        certSelects: [],
        addressStr: '',
        companyOptions: [{
          value: 'sf',
          label: '顺丰'
        }, {
          value: 'db',
          label: '德邦'
        }, {
          value: 'yt',
          label: '圆通'
        }],
        expressCompany: '',
        expressNo: '',
        expressInfo: {},
        loading: false,
        expressed: false,
      };
    },
    created() {
      this.certSelects = this.$route.params.certSelects;
      this.addressStr = this.$route.params.addressStr;
    },
    methods: {
      _certExpress() {
        let certIds = [];
        this.certSelects.forEach((item) => {
          certIds.push(item.id);
        });
        this.loading = true;
        certExpress(this.user.userId, certIds, this.expressCompany, this.expressNo).then((res) => {
          this.loading = false;
          if (res.rspCode === 0) {
            this.expressed = true;
            this.expressInfo = res.expressInfo;
          } else {
            this.expressed = false;
            this.$message.error(res.rspDesc);
          }
        }).catch(() => {
          this.$message.error('系统异常，请重试！');
          this.loading = false;
        });
      },
      _copyAddress() {
        this.$message.success('复制成功');
      },
      _copyError() {
        this.$message.error('复制失败');
      },
    },
    computed: {
      ...mapGetters([
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    height: 100%;
    .title
      margin-bottom: 20px;
    .info-title
      margin-top: 20px;
      margin-bottom: 20px;
      font-weight: 400;
      font-size: 14px;
      color: #606266;
      cursor: text;
    .info-wrapper
      padding: 20px 20px 0 0;
      margin: 0 0 10px 0 !important;
      background: #fff;
    .express-wrapper
      padding: 20px;
      background: #fff;
</style>